// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconSortLowerSide = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5">
            <path
                fill="currentColor"
                d="M6.85076233,0 L0.648262704,0 C0.0717000614,0 -0.216346656,0.697734118 0.190294112,1.10437489 L3.29576286,4.3106246 C3.41951283,4.43671846 3.56482562,4.5 3.74998173,4.5 C3.91528627,4.5 4.08091911,4.43664837 4.20771607,4.30994511 L7.30849775,1.10369539 C7.71560701,0.698437214 7.42732533,0 6.85076269,0 L6.85076233,0 Z"
                transform="translate(.25 .25)"
            />
        </svg>
    );
};

export default React.memo(IconSortLowerSide);
